/*
 * @Author: Diana Resendiz
 * @Date: 2021-11-20 01:05:53
 * @Last Modified by: Diana Resendiz
 * @Last Modified time: 2021-12-06 10:46:50
 */
import { combineEpics } from 'redux-observable';

export default combineEpics();
